/**
 * Recursive scrub walker for Sentry payloads. Replaces values under any
 * key in SENSITIVE_KEYS with '[REDACTED]', anywhere in the object tree.
 *
 * Walks objects, arrays, and primitives. Returns a new value (does NOT
 * mutate input). Used by both Sentry.init's beforeSend and beforeBreadcrumb.
 *
 * Architecture §9 pins the field set; convention doc carries the rationale.
 */
// 'reconnectionToken' is the real Colyseus property name (room.reconnectionToken);
// the config previously redacted 'reconnectToken', which matches nothing (audit 2.15).
export const SENSITIVE_KEYS = new Set(['secretWord', 'role', 'reconnectionToken']);
const REDACTED = '[REDACTED]';
export const scrubSensitive = (value) => {
    if (value === null || value === undefined)
        return value;
    if (typeof value !== 'object')
        return value;
    if (Array.isArray(value))
        return value.map(scrubSensitive);
    const out = {};
    for (const [k, v] of Object.entries(value)) {
        out[k] = SENSITIVE_KEYS.has(k) ? REDACTED : scrubSensitive(v);
    }
    return out;
};
/**
 * Strips the value from a `#access_token=...` URL fragment before it reaches
 * Sentry. Used by client Sentry's beforeSend to prevent OAuth tokens from
 * appearing in breadcrumb URLs or error contexts.
 *
 * Replaces with [REDACTED] to preserve the URL structure (so dashboards can
 * still see "this URL had an access_token fragment" without leaking the value).
 */
export const stripAccessTokenFragment = (url) => url.replace(/#access_token=[^&\s]*/g, '#access_token=[REDACTED]');
//# sourceMappingURL=scrub.js.map